import styled from 'styled-components';

interface StatCardProps {
  background?: string;
  textAlign?: 'left' | 'center' | 'right';
}

export const StatCard = styled.div<StatCardProps>`
  background: ${props => props.background || 'white'};
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: ${props => props.textAlign || 'center'};
`;

export const StatNumber = styled.div`
  font-size: 2rem;
  font-weight: 700;
  color: #667eea;
  margin-bottom: 0.5rem;
`;

export const StatLabel = styled.div`
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 500;
`;